import React, { useLayoutEffect } from "react"
import { motion } from "framer-motion"
import { CombinedRoutes } from "../Common/Routes"
import { Route, Switch } from 'react-router'
import { useDispatch } from "react-redux"
import { setPageTitle } from "../Store/Theme/actions"
import { withRouter } from "react-router-dom"
import TopBar from "../Components/TopBar"
import Footer from "../Components/Footer"
import SideBar from "../Components/SideBar"

const getUrlElem = (url) => {
    let urlSplit = url.split('/')
    let route = CombinedRoutes.filter(c => c.link !== null && c.link.split('/').length === urlSplit.length).find(c => c.link.split('/').every((i, j) => i[0] === ':' || i === urlSplit[j]))
    let urlParams = {}
    route?.link?.split('/').forEach((c, i) => {
        if (c[0] === ':') {
            urlParams[c.slice(1,)] = urlSplit[i]
        }
    })
    let { component: Elem = null, title = null, ItemIcon: icon = null, saveData = false, multiWindow = true } = route || {}
    return { Elem, title, icon, saveData, multiWindow, urlParams }
}


const HomeRoot = ({ history }) => {

    const dispatch = useDispatch()

    // set page title
    useLayoutEffect(() => {
        let path = getUrlElem(history.location.pathname)
        if (path) dispatch(setPageTitle(path.title))
    }, [history.location]) // eslint-disable-line

    return (
        <motion.div className="h-full relative bg-pColor flex">
            <motion.div className="fixed z-10 left-0 top-0 h-full px-1 py-2">
                <SideBar />
            </motion.div>
            <div className="w-full flex flex-col h-full ml-64"> {/* Adjusted margin to make space for the fixed sidebar */}
                <motion.div className="px-1 py-2">
                    <TopBar />
                </motion.div>
                <div className="text-left overflow-auto min-h-screen px-1 py-2 text-tpColor">
                    <Switch>
                        {CombinedRoutes.map(c => (
                            <Route key={c.link} path={c.link} exact component={c.component} />
                        ))}
                    </Switch>
                </div>
                {/* <motion.div className="bottom-0 inset-x-0">
                    <Footer />
                </motion.div> */}
            </div>
        </motion.div>
    )
}

export default withRouter(HomeRoot)